export default __webpack_public_path__ + "static/media/Icon3.d5196bee.svg";